import React from "react";

const BeforAfterTS = ({ beforService, afterService }) => {
  return (
    <div className="d-flex justify-content-between">
      <div style={{ fontSize: "12px" }}>{beforService}</div>
      <div style={{ fontSize: "12px" }}>{afterService}</div>
    </div>
  );
};

export default BeforAfterTS;
